package com.dotdrives.repository

import com.dotdrives.client.GivingSummaryClient
import com.dotdrives.model.GivingSummary
import com.dotdrives.model.ReportFilter

interface GivingSummaryRepository {
    /**
     * [year] selects a calendar-year window (`docs/schema.md` names no fiscal-year field
     * anywhere, so this is a best-effort Jan 1 - Dec 31 stand-in for the design's "FY 2026"
     * filter). [targetId] narrows every figure to one target; null means "All targets".
     */
    suspend fun load(orgId: String, year: Int, targetId: String?): Result<GivingSummary>
    suspend fun load(orgId: String, filter: ReportFilter): Result<GivingSummary> = load(orgId, filter.period.endInclusive.year, filter.targetId)
}

class SupabaseGivingSummaryRepository(
    private val client: GivingSummaryClient = GivingSummaryClient(),
) : GivingSummaryRepository {
    override suspend fun load(orgId: String, year: Int, targetId: String?): Result<GivingSummary> =
        runCatching { client.load(orgId, year, targetId) }
    override suspend fun load(orgId: String, filter: ReportFilter): Result<GivingSummary> = runCatching { client.load(orgId, filter) }
}
